import styled from "styled-components";
import { Badge, Anchor, List } from "@ebscois/react-component-library";

export const StyledBadge = styled(Badge)`
  text-transform: none;
  white-space: nowrap;
  font-size: ${({ theme }) => theme.font.size.xs};
`;

export const StyledAnchor = styled(Anchor)`
  display: inline;
  font-size: ${({ theme }) => theme.font.size.md};
`;

export const StyledList = styled(List)`
  font-size: ${({ theme }) => theme.font.size.xs};
`;
